import React from 'react';
import ProtectedRoute from './ProtectedRoutes';

/**
 * AdminProtectedRoute
 *
 * Drop-in replacement for the old AdminProtectedRoutes.
 * Wraps ProtectedRoute with the system admin roles pre-filled.
 * Can optionally accept extra roles/permissions for finer control.
 *
 * Usage in routes:
 *   <AdminProtectedRoute>
 *     <MainLayout />
 *   </AdminProtectedRoute>
 *
 *   <AdminProtectedRoute roles={['department_head']} permissions={['projects.read']}>
 *     <ProjectLayout />
 *   </AdminProtectedRoute>
 */
const AdminProtectedRoute = ({ children, roles = [], permissions = [], ...props }) => (
    <ProtectedRoute
        roles={['super_admin', 'system_admin', 'technical_support']}
        permissions={permissions}
        {...props}
        // requireAll
    >
        {children}
    </ProtectedRoute>
);

export default AdminProtectedRoute;
